import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalHistoryComponent } from './modal-history.component';
import { SignalDesignModule } from 'src/app/signal-design/signal-design.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [ModalHistoryComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SignalDesignModule,
  ],
  exports: [ModalHistoryComponent]
})
export class ModalHistoryModule { }
